import { Navigate, Route, Routes } from 'react-router';
import { Layout } from './components/Layout.tsx';
import { AdminAuditPage } from './pages/admin/AdminAuditPage.tsx';
import { AdminAvailabilityPage } from './pages/admin/AdminAvailabilityPage.tsx';
import { AdminBuildPage } from './pages/admin/AdminBuildPage.tsx';
import { AdminDistributionPage } from './pages/admin/AdminDistributionPage.tsx';
import { AdminExportPage } from './pages/admin/AdminExportPage.tsx';
import { AdminLayout } from './pages/admin/AdminLayout.tsx';
import { AdminPhysiciansPage } from './pages/admin/AdminPhysiciansPage.tsx';
import { AdminSchedulesPage } from './pages/admin/AdminSchedulesPage.tsx';
import { AdminTodoPage } from './pages/admin/AdminTodoPage.tsx';
import { AdminUsersPage } from './pages/AdminUsersPage.tsx';
import { CalendarPage } from './pages/CalendarPage.tsx';
import { ChangePasswordPage } from './pages/ChangePasswordPage.tsx';
import { HistoryPage } from './pages/HistoryPage.tsx';
import { RequestPeriodPage } from './pages/RequestPeriodPage.tsx';
import { RequestsPage } from './pages/RequestsPage.tsx';
import { SchedulePage } from './pages/SchedulePage.tsx';
import { SignInPage } from './pages/SignInPage.tsx';
import { SessionProvider, useSession } from './session.tsx';

function Gate() {
  const { user } = useSession();
  if (user === undefined) return null;
  if (user === null) return <SignInPage />;
  if (user.mustChangePassword) return <ChangePasswordPage />;
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route path="/" element={<SchedulePage />} />
        <Route path="/schedules/:id" element={<SchedulePage />} />
        <Route path="/history" element={<HistoryPage />} />
        <Route path="/calendar" element={<CalendarPage />} />
        <Route path="/requests" element={<RequestsPage />} />
        <Route path="/requests/:id" element={<RequestPeriodPage />} />
        <Route path="/password" element={<ChangePasswordPage mode="own" />} />
        {user.isAdmin ? (
          <Route path="/admin" element={<AdminLayout />}>
            {/* The Admin tab opens on what is waiting (owner, 24 October 2026). */}
            <Route index element={<Navigate to="/admin/todo" replace />} />
            <Route path="todo" element={<AdminTodoPage />} />
            <Route path="build" element={<AdminBuildPage />} />
            <Route path="schedules" element={<AdminSchedulesPage />} />
            <Route path="distribution" element={<AdminDistributionPage />} />
            <Route path="availability" element={<AdminAvailabilityPage />} />
            <Route path="physicians" element={<AdminPhysiciansPage />} />
            <Route path="users" element={<AdminUsersPage />} />
            <Route path="audit" element={<AdminAuditPage />} />
            <Route path="export" element={<AdminExportPage />} />
          </Route>
        ) : null}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
  );
}

export function App() {
  return (
    <SessionProvider>
      <Gate />
    </SessionProvider>
  );
}
